import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass($setup.cn('flex min-h-0 w-full flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden', $setup.props.class)),
        "data-sidebar": "content",
        "data-slot": "sidebar-content"
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */));
}
